import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const user = localStorage.getItem('userInfo');
    if (user) {
      this.router.navigate(['/er']); // redirige al layout protegido
      return false;
    } else {
      return true; // deja entrar a auth (login/registro)
    }
  }
}
